<template>
  <div class="order mpd">
    <slot v-if="userinfo">
      <Title title="购买门票"></Title>

      <div class="common" v-if="active === 'common'">
        <BuyTicket></BuyTicket>
        <Tips :meetTime="meetTime"></Tips>
      </div>

      <iframe
        v-if="active === 'special'"
        style="width: 100%; height: 1500px; margin-top: 120px"
        :src="`https://case.msup.com.cn/pay/pay-submit.html?hash=${hash}`"
      ></iframe>

      <div class="line"></div>
    </slot>
    <div v-else style="width:100vw;height:100vh;background-color:#FFFFFF;"></div>
  </div>
</template>

<script>
// import global from "../Global.vue"

export default {
  name: 'OrderNew',
  components: {
    Title: () => import('@/components/Title'),
    Tips: () => import('@/components/order/Tips.vue'),
    BuyTicket: () => import('@/components/order/BuyTicket.vue')
  },
  data () {
    return {
      type: '',
      meetTime: '',
      hash: '',
      active: 'common',
      userinfo: false
    }
  },
  created () {
    // if (!this.global.config[this.global.area_id]['haslive']) {
    //   this.$router.push({path: '/home', query: {sid: this.global.area_id}})
    // }
    // this.checkUserInfo();
    // this.getTime();
    // this.isHashTrue();
  },
  mounted () {
    if (!window.localStorage.getItem('linkurl')) {
      this.checkUserInfo()
    }
    this.getTime()
    this.isHashTrue()
  },
  methods: {
    getTime () {
      this.$http
        .jsonp(`${this.global.url.place}${this.global.area_id}`)
        .then((data) => {
          return data.json()
        })
        .then((res) => {
        //   console.log(res);
          this.meetTime = this.formatTime(res.data.startTime, 'start')
        })
    },
    formatTime (timestamp, tag) {
      const time = new Date(timestamp * 1000)
      const year = time.getFullYear()
      let month = time.getMonth() + 1
      let day = time.getDate()
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      if (tag === 'start') {
        return `${year}年${month}月${day}日`
      } else {
        return `${month}.${day}`
      }
    },
    // 判断hash是否合格(qd是否正确)
    isHashTrue () {
      // console.log(this.global.hashParam);
      this.hash = this.$route.query.qd ? this.$route.query.qd : this.global.hashParam.qd
      if (this.hash === undefined) {
        return false
      } else {
        this.global.hashParam.qd = this.hash
      }

      this.$http
        .jsonp(`${this.global.url.checkhash}?hash=${this.hash}`)
        .then((data) => {
          return data.json()
        })
        .then((res) => {
          console.log(res)
          if (res.status === '200') {
            this.active = 'special'
          } else {
            this.active = 'common'
          }
        })
    },
    // 检查用户状态（是否存在/是否登录/登录状态是否过期）
    checkUserInfo () {
      const token = window.localStorage.getItem('token')
      if (token && token !== null) {
        let url = `${this.global.url.user.info}?token=${token}`
        this.$http
          .jsonp(url)
          .then((data) => {
            return data.json()
          })
          .then((res) => {
            // console.log('check_userInfo ', res)
            if (res.status === '200') {
              let flag = true
              for (const key in res.data) {
                if (res.data[key] === '') {
                  this.userinfo = false
                  flag = false
                  if (window.confirm('购票需要您先完善个人信息')) {
                    this.$router.push({
                      path: `/user_center`,
                      query: { active: '5' }
                    })
                  }
                  break
                }
              }
              if (flag) {
                this.userinfo = true
              }
            } else if (res.code === '1001' || res.status === '1011') {
              this.userinfo = false
              this.$message({
                message: '当前登录状态已过期，请重新登录',
                type: 'warning'
              })
              window.localStorage.removeItem('logins')
              window.localStorage.removeItem('token')
              let order = `/order` + `${this.global.hashParam.qd ? '?qd=' + this.global.hashParam.qd : ''}`
              window.localStorage.setItem('linkurl', order)
              setTimeout(() => {
                this.$router.push({ path: '/login', query: {sid: this.global.area_id} })
              }, 2000)
            } else {
              console.log('获取用户信息失败')
            }
          })
      } else {
        this.$message({
          message: '当前登录状态已过期，请重新登录',
          type: 'warning'
        })
        window.localStorage.removeItem('logins')
        window.localStorage.removeItem('token')
        let order = `/order` + `${this.global.hashParam.qd ? '?qd=' + this.global.hashParam.qd : ''}`
        window.localStorage.setItem('linkurl', order)
        setTimeout(() => {
          this.$router.push({ path: '/login', query: {sid: this.global.area_id} })
        }, 2000)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/css/reset.css";

.mpd {
  --main-color: #1889CB;
}
.order {
  .line {
    width: 100%;
    max-width: 1200px;
    height: 1px;
    margin: 0 auto;
    background: #f1f4f7;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/OrderNew.vue